import { LogOut, Settings, User as UserIcon } from "lucide-react";
import { Avatar, AvatarFallback } from "../ui/avatar.js";
import { Button } from "../ui/button.js";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "../ui/dropdown-menu.js";

export interface UserMenuProps {
  name: string;
  role: string;
  initials: string;
  onSignOut?: () => void;
  /** Menu entries appear only when the app wires them — never a dead menu item. */
  onProfile?: () => void;
  onSettings?: () => void;
}

export function UserMenu({ name, role, initials, onSignOut, onProfile, onSettings }: UserMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="gap-2 px-1.5" aria-label={`Account menu for ${name}`}>
          <Avatar>
            <AvatarFallback>{initials}</AvatarFallback>
          </Avatar>
          <span className="hidden flex-col items-start leading-tight lg:flex">
            <span className="text-sm font-medium text-foreground">{name}</span>
            <span className="text-xs text-muted-foreground">{role}</span>
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>
          <div className="flex flex-col gap-0.5">
            <span className="text-sm font-medium text-foreground">{name}</span>
            <span className="text-xs font-normal text-muted-foreground">{role}</span>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {onProfile && (
          <DropdownMenuItem onSelect={() => onProfile()}>
            <UserIcon className="size-4" />
            Profile
          </DropdownMenuItem>
        )}
        {onSettings && (
          <DropdownMenuItem onSelect={() => onSettings()}>
            <Settings className="size-4" />
            Settings
          </DropdownMenuItem>
        )}
        {(onProfile ?? onSettings) && <DropdownMenuSeparator />}
        <DropdownMenuItem onSelect={() => onSignOut?.()} className="text-danger focus:bg-danger/10">
          <LogOut className="size-4" />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
